module.exports = __webpack_public_path__ + "static/media/whatsapp_guide_mobile_06.97459668.png";